import React, { useState, useEffect, useCallback, useRef } from "react";
import FormFilters from "./form-filters";
import { Card, Col, Row, Spinner, ProgressBar } from "react-bootstrap";
import { ReportKmService } from "../../../services/apiService";
import ReportTableKM from "./components/table-km";
import CardDetailKM from "./components/card-detail-km";
import DetailChartKm from "./components/chart_km/detail-chart-km";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import withReactContent from "sweetalert2-react-content";

import { transformarRespuestaDistance } from "../../../utils/useKilometrajeCalculations";
import {
  calcularResumenUnidad,
  normalizarFiltros, // ✅ IMPORTAR NUEVA FUNCIÓN
} from "../../../utils/useReporteCalculations";

import { cargarDistanciaVehiculosStream } from "../../../providers/provider_paginado";
//import { paginadoKilometrajeStore } from '../../../lib/store/paginador_store';
import { paginadoKilometrajeStore } from "../../../lib/store/paginador_store";

import classNames from "classnames";

import PrintReportModule from "../../../components/print/PrintReportModule";
import VehiculoKilometraje from "./components/vehiculo-kilometraje/VehiculoKilometraje";
import FechaKilometraje from "./components/fecha-kilometraje/FechaKilometraje";
import {
  LoadingEmptyState,
  NoDataEmptyState,
  NoSelectionEmptyState,
  WelcomeEmptyState,
} from "../../../components/common/EmptyState";
import StandardProgressBar from '../../../components/common/ProgressBar/StandardProgressBar';


// Componente de estado vacío reutilizable
const EmptyState = ({ icon, title, message, isLoading }) => (
  <Card className="mt-3 text-center py-5">
    <Card.Body
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ minHeight: "40vh" }}
    >
      {isLoading ? (
        <>
          <Spinner
            animation="border"
            variant="primary"
            style={{ width: "4rem", height: "4rem", marginBottom: "1.5rem" }}
          />
          <h4 className="text-primary mb-3">Cargando datos...</h4>
          <p className="text-muted mb-0 w-75">
            Estamos procesando tu solicitud, esto puede tomar unos momentos.
          </p>
        </>
      ) : (
        <>
          <div className="mb-3 text-muted" style={{ fontSize: "4rem" }}>
            {icon || <i className="far fa-calendar-alt"></i>}
          </div>
          <h4 className="mb-3">{title}</h4>
          <p className="text-muted mb-0 w-75">{message}</p>
        </>
      )}
    </Card.Body>
  </Card>
);

//Modulo Principal react
const IndexReportKM = () => {

  // Estado para controlar el spinner
  const [isLoading, setIsLoading] = useState(false);
  const [reportList, setReportList] = useState([]);
  const MySwal = withReactContent(Swal);
  const [filtrosLocal, setFiltrosLocal] = useState(null);
  const [totalCarga, setTotalCarga] = useState([]);
  const [vehiculos, setVehiculos] = useState([]);
  const paginadorKilometraje = paginadoKilometrajeStore();
  const [searchValue, setSearchValue] = useState("");
  const cleanupRef = useRef(null);

  /*estados para fecha kilometraje*/
  const [highlightedFecha, setHighlightedFecha] = useState(null);
  const [fechaFiltrada, setFechaFiltrada] = useState(null);

  const [highlightedVehicle, setHighlightedVehicle] = useState(null);
  const [vehiculoFiltrado, setVehiculoFiltrado] = useState(null);

  //estado para controlar los filtros del reporte
  const [filters, setFilters] = useState({
    fecha_inicio: new Date(new Date().setHours(0, 0, 0, 0)).toISOString(),
    fecha_fin: new Date(new Date().setHours(23, 59, 59, 999)).toISOString(),
    uids_vehiculos: [],
    distancia_1: 0.0,
    distancia_2: 0.0,
  });

  const shouldShowEmptyState = useCallback(() => {
    if (isLoading) return true;

    if (
      !filters ||
      !filters.uids_vehiculo ||
      filters.uids_vehiculo.length === 0
    ) {
      return true;
    }

    if (reportList.length === 0 && !paginadorKilometraje.cargando) {
      return true;
    }

    return false;
  }, [isLoading, filters, reportList.length, paginadorKilometraje.cargando]);

  const getEmptyStateProps = useCallback(() => {
    if (
      !filters ||
      !filters.uids_vehiculo ||
      filters.uids_vehiculo.length === 0) {
      return {
        component: <NoSelectionEmptyState reportType={'kilómetros'} entityType='kilómetros' />,
        show: true
      };
    }

    return {
      component: <NoDataEmptyState reportType={'kilómetros'} entityType='kilómetros' />,
      show: true
    };
  }, [filters]);

  const [loadingComponents, setLoadingComponents] = useState({
    table: { loading: false, progress: 0, complete: false },
    vehicles: { loading: false, progress: 0, complete: false }
  });

  const calculateTotalProgress = useCallback(() => {
    const weights = {
      table: 0.4,      // ✅ Ajustar para que sume 100%
      vehicles: 0.3,   // ✅ Solo componentes que existen
      alerts: 0.3,     // ✅ Solo componentes que existen                
    };

    let totalProgress = 0;
    let totalWeight = 0;

    Object.entries(loadingComponents).forEach(([component, state]) => {
      if (state && (state.loading || state.complete)) {
        const progress = Number(state.progress);
        if (!isNaN(progress)) {
          totalProgress += progress * weights[component];
          totalWeight += weights[component];
        } else {
          totalProgress += (state.complete ? 100 : 0) * weights[component];
          totalWeight += weights[component];
        }
      }
    });

    if (totalWeight === 0) return 0;
    const result = totalProgress / totalWeight;

    return Math.min(Math.max(result, 0), 100);
  }, [loadingComponents]);

  const [debugMetrics, setDebugMetrics] = useState({
    searchStartTime: null,
    searchEndTime: null,

    connections: {
      'ListTable': {
        name: 'Bitacora (GPS)',
        startTime: null,
        endTime: null,
        totalRecordsExpected: 0,
        totalRecordsReceived: 0,
        totalApiCalls: 0,
        completedApiCalls: 0,
        failedApiCalls: 0,
        recoveredApiCalls: 0,
        apiCallsHistory: [],
        downloadProgress: 0,
        status: 'pending'
      }
    },

    globalTotalRecordsExpected: 0,
    globalTotalRecordsReceived: 0,
    globalDownloadProgress: 0,
    activeConnections: 0,

    componentTimes: {
      table: { start: null, end: null },
      vehicles: { start: null, end: null },
      alerts: { start: null, end: null },
    }
  });

  const updateComponentProgress = useCallback((component, progress, isComplete = false) => {
    setLoadingComponents(prevState => {
      const newState = { ...prevState };

      if (newState[component]) {
        newState[component] = {
          ...newState[component],
          loading: !isComplete,
          progress: isComplete ? 100 : Math.max(0, Math.min(100, progress)),
          complete: isComplete
        };
      }

      return newState;
    });

    // ✅ Actualizar métricas directamente sin dependencia circular
    setDebugMetrics(prev => ({
      ...prev,
      componentTimes: {
        ...prev.componentTimes,
        [component]: {
          start: !isComplete ? Date.now() : (prev.componentTimes[component]?.start || Date.now()),
          end: isComplete ? Date.now() : null
        }
      }
    }));
  }, []);

  const updateDebugMetrics = useCallback((updates) => {
    setDebugMetrics(prev => {
      if (!prev || !prev.connections) {
        console.warn('⚠️ debugMetrics no está inicializado correctamente');
        return prev || {
          connections: {},
          globalTotalRecordsExpected: 0,
          globalTotalRecordsReceived: 0,
          globalDownloadProgress: 0,
          activeConnections: 0,
          componentTimes: {}
        };
      }
      const newState = { ...prev };

      if (updates.connectionId && newState.connections[updates.connectionId]) {
        const connection = newState.connections[updates.connectionId];

        if (!connection.apiCallsHistory) {
          connection.apiCallsHistory = [];
        }

        // Actualizar datos específicos de la conexión
        Object.keys(updates).forEach(key => {
          if (key !== 'connectionId') {
            if (key === 'apiCallsHistory' && Array.isArray(updates[key])) {
              const newCalls = updates[key].map(call => ({
                ...call,
                timestamp: call.timestamp || Date.now()
              }));
              connection[key] = [...(connection[key] || []), ...newCalls];

              if (connection[key].length > 50) {
                connection[key] = connection[key].slice(-50);
              }
            } else if (key !== 'apiCallsHistory') {
              connection[key] = updates[key];
            }
          }
        });

        const activeConnections = Object.values(newState.connections).filter(conn =>
          conn && (conn.status === 'downloading' || conn.status === 'completed')
        );

        newState.globalTotalRecordsExpected = activeConnections.reduce((sum, conn) =>
          sum + (conn.totalRecordsExpected || 0), 0
        );

        newState.globalTotalRecordsReceived = activeConnections.reduce((sum, conn) =>
          sum + (conn.totalRecordsReceived || 0), 0
        );

        newState.globalDownloadProgress = newState.globalTotalRecordsExpected > 0 ?
          (newState.globalTotalRecordsReceived / newState.globalTotalRecordsExpected * 100) : 0;

        newState.activeConnections = activeConnections.length;

      } else if (updates.connectionId && !newState.connections[updates.connectionId]) {
        newState.connections[updates.connectionId] = {
          name: updates.connectionId,
          startTime: null,
          endTime: null,
          totalRecordsExpected: 0,
          totalRecordsReceived: 0,
          totalApiCalls: 0,
          completedApiCalls: 0,
          failedApiCalls: 0,
          recoveredApiCalls: 0,
          apiCallsHistory: [],
          downloadProgress: 0,
          status: 'pending'
        };

        Object.keys(updates).forEach(key => {
          if (key !== 'connectionId') {
            newState.connections[updates.connectionId][key] = updates[key];
          }
        });

      } else {
        Object.keys(updates).forEach(key => {
          if (key === 'componentTimes') {
            if (!newState.componentTimes) {
              newState.componentTimes = {};
            }
            newState.componentTimes = { ...newState.componentTimes, ...updates.componentTimes };
          } else if (key !== 'connectionId') {
            newState[key] = updates[key];
          }
        });
      }

      return newState;
    });

    // ✅ SINCRONIZAR DESCARGA CON BARRA DE PROGRESO
    /*if (updates.connectionId && updates.downloadProgress !== undefined) {
      setTimeout(() => {
        const componentMapping = {
          'ListTable': 'list'
        };

        const componentName = componentMapping[updates.connectionId];

        if (componentName) {
          // ✅ Usar el progreso real de descarga para actualizar el componente
          const isComplete = updates.downloadProgress >= 100;
          const progressValue = Math.round(updates.downloadProgress || 0);

          console.log(`🔄 [Sincronización] ${componentName}: ${progressValue}% (descarga ${isComplete ? 'completa' : 'en progreso'})`);

          updateComponentProgress(componentName, progressValue, isComplete);

          // ✅ Si la descarga está completa, también marcar como cargando = false
          if (isComplete) {
            setLoadingComponents(prevState => ({
              ...prevState,
              [componentName]: {
                loading: false,
                progress: 100,
                complete: true
              }
            }));
          }
        }
      }, 0);
    }*/
  }, [updateComponentProgress]);


  useEffect(() => {
    // ✅ LIMPIAR DATOS ANTIGUOS DE LOCALSTORAGE AL INICIALIZAR
    // Esto evita conflictos con la nueva implementación de IndexedDB
    try {
      // Limpiar específicamente la clave que causaba problemas
      if (window.localStorage.getItem("dates_km_all")) {
        console.log("Limpiando datos antiguos de localStorage...");
        window.localStorage.removeItem("dates_km_all");
      }
    } catch (error) {
      console.warn("No se pudo limpiar localStorage:", error);
    }

    if (!window.printReportModule) {
      window.printReportModule = new PrintReportModule({
        captureQuality: 0.95,
        pdfFormat: "A4",
        pdfOrientation: "landscape",
        useNativeTables: true,
        maxRowsPerPage: 30,
        tableFontSize: 7,

        // ✅ CONFIGURACIÓN ESPECÍFICA PARA KILOMETRAJE
        reportType: "kilometraje",
        captureContainer: "#reporte-kilometraje-content",

        tableExtractionConfig: {
          enabled: true,
          selector: "#tabla-kilometraje",
          title: "Listado de Kilometraje",
          type: "html", // html, tanstack, dual-table
          headerSelector: "thead th, thead td",
          bodySelector: "tbody tr",
          cellSelector: "td",
          // ✅ Transformaciones opcionales
          cellTransforms: {
            'button[class*="btn"]': "Ver Mapa",
            ".fa-map-marker-alt": "Ver Ubicación",
          },
        },

        // 📊 ESTRATEGIA HORIZONTAL: Capturar por filas (recomendado para landscape)
        horizontalStrategy: "rows",
        horizontalRows: [
          {
            title: "Resumen y Gráfico de Kilometraje",
            selector: ".g-3:first-of-type", // Primera fila con las dos cards
            identifier: "kilometraje-fila-1",
            selectorMethod: "direct",
          },
          // {
          //   title: 'Tabla de Kilometraje',
          //   selector: '.g-3:nth-of-type(2)', // Segunda fila con la tabla
          //   identifier: 'kilometraje-fila-2',
          //   selectorMethod: 'direct'
          // }
        ],

        // 📱 ESTRATEGIA VERTICAL: Capturar targets individuales (para portrait)
        verticalStrategy: "targets",
        captureTargets: [
          {
            title: "Resumen de Kilometraje",
            selector: "#card-detail-km",
            type: "card",
          },
          {
            title: "Gráfico de Kilometraje por Día",
            selector: "#chart-km-detalle",
            type: "card",
          },
          // {
          //   title: 'Tabla de Kilometraje',
          //   selector: '#tabla-kilometraje',
          //   type: 'card'
          // }
        ],
      });
    }

    return () => {
      if (window.printReportModule) {
        delete window.printReportModule;
      }
      // Cancelar stream SSE activo al desmontar
      if (cleanupRef.current) {
        cleanupRef.current();
        cleanupRef.current = null;
      }
    };
  }, []);

  const handleGenerateReport = async (selectedFilters) => {
    setVehiculos(selectedFilters.vehiculos);
    console.log("Filtros en kilometraje:", selectedFilters);

    // ✅ NORMALIZAR FILTROS
    const filtrosNormalizados = normalizarFiltros(selectedFilters);

    setFilters(filtrosNormalizados);

    // Reiniciar datos
    setReportList([]);

    updateComponentProgress('alerts', 5, false);
    updateComponentProgress('vehicles', 5, false);
    updateComponentProgress('table', 0, false);
    await new Promise(resolve => setTimeout(resolve, 100));
    // Reiniciar paginador
    paginadorKilometraje.editarDatos([]);
    paginadorKilometraje.editarProgresoCargado(0);
    setTotalCarga([]);

    setFiltrosLocal(filtrosNormalizados);
  };

  // useEffect para iniciar la carga cuando cambien los filtros
  useEffect(() => {

    const loadEstadiasReport = async () => {
      setIsLoading(true);

      // ✅ ESTABLECER TIEMPO DE INICIO SI NO ESTÁ YA ESTABLECIDO
      setDebugMetrics(prev => ({
        ...prev,
        searchStartTime: prev.searchStartTime || Date.now(),
        searchEndTime: null
      }));

      // ✅ MARCAR COMPONENTE COMO CARGANDO AL INICIAR DESCARGA
      setLoadingComponents(prevState => ({
        ...prevState,
        table: { loading: true, progress: 0, complete: false }
      }));

      updateComponentProgress('table', 10, false);

      // ✅ USAR FILTROS NORMALIZADOS
      const filtrosFormateados = normalizarFiltros(filtrosLocal);
      const connectionId = 'ListTable';
      const vehicleCount = filtrosFormateados.uids_vehiculo?.length || 0;

      // Siempre usar SSE Stream — soporta desde 1 hasta 3000+ vehículos
      console.log(`📡 KM: Usando SSE Stream para ${vehicleCount} vehículos`);

      const abortController = new AbortController();
      cleanupRef.current = () => abortController.abort();

      // Inicializar paginador ANTES de llamar al stream
      paginadorKilometraje.editarCargando(true);
      paginadorKilometraje.editarCargaCompletada(false);
      paginadorKilometraje.editarDatos([]);
      paginadorKilometraje.editarProgresoCargado(0);
      paginadorKilometraje.editarError(null);

      await cargarDistanciaVehiculosStream(
        process.env.REACT_APP_VEHICLE_DISTANCE_STREAM_URL,
        paginadorKilometraje,
        filtrosFormateados,
        connectionId,
        (updates) => {
          updateDebugMetrics({ ...updates, connectionId });
          if (updates.downloadProgress) {
            updateComponentProgress('vehicles', updates.downloadProgress * 0.8, false);
          }
        },
        abortController.signal
      );
    };
    // Cancelar stream anterior si hay uno activo
    if (cleanupRef.current) {
      cleanupRef.current();
      cleanupRef.current = null;
    }
    if (
      paginadorKilometraje.cargando === false &&
      filtrosLocal !== null &&
      filtrosLocal.uids_vehiculo?.length > 0
    ) {
      loadEstadiasReport();
    }
  }, [filtrosLocal]);

  // useEffect para procesar los datos cargados
  useEffect(() => {
    // 1. Comprobar que tenemos datos y filtros
    if (
      !paginadorKilometraje.datos ||
      !Array.isArray(paginadorKilometraje.datos) ||
      !filtrosLocal
    ) {

      // ✅ Completar carga de tabla
      return; // Salir temprano si no tenemos datos o filtros
    }

    // 2. Verificar si estamos en estado de carga con datos vacíos
    if (
      paginadorKilometraje.datos.length === 0 &&
      paginadorKilometraje.cargando
    ) {
      // Seguimos en estado de carga, no hacer nada aún
      return;
    }

    // 3. Si realmente no hay datos después de terminar la carga
    if (
      paginadorKilometraje.datos.length === 0 &&
      !paginadorKilometraje.cargando
    ) {
      console.log(
        "No se encontraron datos de kilometraje para el vehículo seleccionado"
      );
      setReportList([]);
      if (paginadorKilometraje.cargaCompletada) {
        updateComponentProgress('alerts', 100, true);
        updateComponentProgress('vehicles', 100, true);
        updateComponentProgress('table', 100, true);
        setIsLoading(false);
      }
      //setIsLoading(false);
      return;
    }

    try {
      // 4. Procesar los datos cuando existen
      console.log(
        "Datos originales kilometraje:",
        paginadorKilometraje.datos[0]
      );

      // Procesar datos del endpoint /distance
      const reporteKilometraje =
        transformarRespuestaDistance(paginadorKilometraje.datos, filtrosLocal) ||
        [];

      if (reporteKilometraje.length === 0) {
        console.warn("transformarRespuestaDistance devolvió un array vacío");
        updateComponentProgress('table', 100, true);
        setIsLoading(false);
        return;
      }

      //fechaFiltrada - fechaCorta
      // console.log("Reporte procesado:", reporteKilometraje[0]);
      // console.log("Reporte procesado completo:", reporteKilometraje);
      // console.log("Fecha Filtrada: ", fechaFiltrada);
      // console.log("vehiculo Filtrado: ", vehiculoFiltrado);

      let reportBeforeFilter = [...reporteKilometraje];

      if (fechaFiltrada) {
        reportBeforeFilter = reportBeforeFilter.filter((item) =>
          item.fechaCorta.toLowerCase().includes(fechaFiltrada.toLowerCase())
        );
      }

      if (vehiculoFiltrado) {
        reportBeforeFilter = reportBeforeFilter.filter((item) =>
          `${item.noEconomico || "N/A"} / ${item.aliasVehiculo || "N/A"}`
            .toLowerCase()
            .includes(vehiculoFiltrado.toLowerCase())
        );
      }

      // Actualizar el estado con los datos procesados
      setReportList(reportBeforeFilter);
    } catch (error) {
      console.error("Error al procesar datos de kilometraje:", error);
      setReportList([]);
    } finally {
      updateComponentProgress('alerts', 100, true);
      updateComponentProgress('vehicles', 100, true);
      updateComponentProgress('table', 100, true);
      setIsLoading(false);
    }
  }, [
    paginadorKilometraje.datos,
    paginadorKilometraje.cargando,
    filtrosLocal,
    fechaFiltrada,
    vehiculoFiltrado,
  ]);

  // Actualizar indicador de progreso
  useEffect(() => {
    if (paginadorKilometraje.progresoCargado > 0) {

      // Actualizar el indicador de progreso
      const isComplete = paginadorKilometraje.progresoCargado >= 100;
      updateComponentProgress('table', paginadorKilometraje.progresoCargado, isComplete);

      setTotalCarga([
        {
          title: "Total de reporte cargado",
          percent: paginadorKilometraje.progresoCargado,
          color: "#2770e9",
          animated: true,
        },
      ]);
    }
  }, [paginadorKilometraje.progresoCargado]);

  let groupedRecords = reportList.reduce((acc, record) => {
    // Obtiene identificador del vehículo
    const key = record.vehiculoUid;

    // Crea los parámetros del agrupado si no existen
    if (!acc[key]) {
      acc[key] = {
        ...record,
        children: [],
        totalDias: 0,
        PromedioDia: 0,
        totalKM: 0,
        // Conjunto para almacenar fechas únicas
        fechasUnicas: new Set(),
      };
    }

    // Agregar la fecha al conjunto (solo se añadirá si es única)
    // Usa la fecha corta (YYYY/MM/DD) para comparar solo por día
    acc[key].fechasUnicas.add(record.fechaCorta);

    // Acumular kilómetros
    acc[key].PromedioDia += parseFloat(record.promedio_distancia);
    acc[key].totalKM += parseFloat(record.promedio_distancia);

    // Agregar al array de hijos
    acc[key].children.push(record);
    acc[key].children = acc[key].children.sort(
      (a, b) => dayjs(a.fecha) - dayjs(b.fecha)
    );
    return acc;
  }, {});

  // Después de la agrupación, calcular el total de días a partir del Set
  Object.values(groupedRecords).forEach((group) => {
    // Establecer el total de días como el tamaño del Set (días únicos)
    group.totalDias = group.fechasUnicas.size;
    // Eliminar el Set ya que no es necesario para la visualización
    delete group.fechasUnicas;
  });

  const getPercentageKM = (totalKM, cantDays) => {
    let percentaje = 0;

    if (totalKM && totalKM > 0) {
      percentaje = (parseFloat(totalKM) / parseInt(cantDays)).toFixed(2);
    }

    return percentaje;
  };

  const formattedData = Object.values(groupedRecords).map((item, index) => ({
    ...item,
    cliente:
      "Promedio Día (km): " + getPercentageKM(item.totalKM, item.totalDias),
    fechaCorta: "Dias Analizados: " + item.totalDias.toString(),
    imei: " ",
    promedio_distancia:
      "Distancia total: " +
      parseFloat(item.totalKM).toFixed(2).toString() +
      " Km",
  }));

  const listChartData = reportList;

  // ✅ FUNCIÓN PARA MANEJAR LA SELECCIÓN DE VEHÍCULO
  const handleSelectVehicle = (vehiculoInfo) => {
    console.log("Vehículo seleccionado:", vehiculoInfo);
    setHighlightedVehicle(vehiculoInfo.title);
    setVehiculoFiltrado(vehiculoInfo.title);

    // Aquí puedes agregar lógica adicional, como:
    // - Filtrar la tabla por el vehículo seleccionado
    // - Mostrar detalles específicos del vehículo
    // - Actualizar otros componentes
  };

  // ✅ FUNCIÓN PARA REMOVER EL FILTRO
  const handleRemoveFiltro = () => {
    setHighlightedVehicle(null);
    setVehiculoFiltrado(null);
  };

  // ✅ PROCESAR DATOS PARA EL COMPONENTE VehiculoKilometraje
  const datosVehiculosKM = Object.values(groupedRecords).map((vehiculo) => {
    return {
      vehiculoUid: vehiculo.vehiculoUid,
      title: `${vehiculo.noEconomico || "N/A"} / ${vehiculo.aliasVehiculo || "N/A"
        }`,
      no_economico: vehiculo.no_economico,
      alias: vehiculo.alias,
      totalKM: vehiculo.totalKM,
      totalDias: vehiculo.totalDias,
      fechaCorta: vehiculo.fechaCorta,
      tipo_vehiculo: vehiculo.tipo_vehiculo || "sedan", // default
      color_vehiculo:
        vehiculos.find((w) => w.value === vehiculo.vehiculoUid)
          .color_vehiculo || "#000000", // default
    };
  });

  // ✅ FUNCIÓN PARA MANEJAR LA SELECCIÓN DE FECHA
  const handleSelectFecha = (fechaInfo) => {
    console.log("Fecha seleccionada:", fechaInfo);
    setHighlightedFecha(fechaInfo.fecha);
    setFechaFiltrada(fechaInfo.fecha);
  };

  // ✅ FUNCIÓN PARA REMOVER EL FILTRO DE FECHA
  const handleRemoveFiltroFecha = () => {
    setHighlightedFecha(null);
    setFechaFiltrada(null);
  };

  return (
    <>
      <div className=" m-3 ">
        <Row>
          <Col md={10}>
            <h4 className="mt-2">Kilómetros</h4>
          </Col>
        </Row>
      </div>

      <Card className="p-3 mb-3 mt-3">
        <hr className="text-danger" />

        <FormFilters
          onGenerateReport={handleGenerateReport}
          imprimir={
            !filtrosLocal
              ? false
              : isLoading
                ? false
                : reportList.length === 0
                  ? false
                  : true
          }
        />

        {/* Barra de progreso durante la carga */}
        {(
          // <Col md={12}>
          //   <Row>
          //     <Col
          //       xs={6}
          //       sm="auto"
          //       className="pe-2 small py-2 d-flex align-items-center"
          //     >
          //       <span
          //         className="dot"
          //         style={{
          //           backgroundColor: "#2770e9",
          //           width: 10,
          //           height: 10,
          //           borderRadius: "50%",
          //           display: "inline-block",
          //           marginRight: 5,
          //         }}
          //       ></span>
          //       <span>Generando reporte...</span>
          //       <span className="ms-1">
          //         (
          //         {`${(totalCarga.length > 0
          //           ? totalCarga[0].percent
          //           : 0
          //         ).toFixed(0)}%`}
          //         )
          //       </span>
          //     </Col>
          //   </Row>
          //   <ProgressBar
          //     style={{ height: 10 }}
          //     className="shadow-none rounded-4 mb-3"
          //   >
          //     {totalCarga.map((item) => (
          //       <ProgressBar
          //         style={{ backgroundColor: item.color }}
          //         now={item.percent}
          //         key={item.title}
          //         animated={item.animated}
          //         className={classNames(
          //           "overflow-visible position-relative rounded-pill"
          //         )}
          //       />
          //     ))}
          //   </ProgressBar>
          // </Col>
          <Row>
            <Col md={12}>
              <StandardProgressBar
                calculateTotalProgress={calculateTotalProgress}
                debugMetrics={debugMetrics}
              />
            </Col>
          </Row>
        )}
      </Card>

      {/* ESTADOS VISUALES INTEGRADOS */}
      {!filtrosLocal ? (
        <WelcomeEmptyState reportType="kilómetros" />
      ) : (paginadorKilometraje.cargando || Object.values(loadingComponents).some(
        (c) => c.loading
      )) ? (
        <LoadingEmptyState reportType="kilómetros" />
      ) : shouldShowEmptyState() ? (
        getEmptyStateProps().component
      ) : (
        // Hay datos, mostrar el reporte completo
        <>
          <div id="reporte-kilometraje-content" data-report-area="kilometraje">
            <Row className="g-3">
              <Col md={6}>
                <FechaKilometraje
                  data={reportList}
                  onSelectFecha={handleSelectFecha}
                  highlightedFecha={highlightedFecha}
                  fechaFiltrada={fechaFiltrada}
                  handleFiltro={handleRemoveFiltroFecha}
                  title="KM por Fecha"
                />
              </Col>

              <Col md={6}>
                <VehiculoKilometraje
                  data={datosVehiculosKM || []}
                  onSelectVehicle={handleSelectVehicle}
                  highlightedVehicle={highlightedVehicle}
                  vehiculoFiltrado={vehiculoFiltrado}
                  handleFiltro={handleRemoveFiltro}
                  title="KM por Vehículo"
                />
              </Col>
            </Row>

            {/* Tabla de datos */}
            <Row className="g-3">
              <Col md={12}>
                <div id="tabla-kilometraje">
                  <ReportTableKM
                    data={formattedData}
                    title={"Listado KM"}
                    isGroup={false}
                    searchValue={searchValue}
                    onSearch={setSearchValue}
                    filtrosLocal={filtrosLocal}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </>
      )}
    </>
  );
};

export default IndexReportKM;
